module.exports = __webpack_public_path__ + "fd84b01a9b01876425559a775d2e7c6d.svg";